import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormChipService {
  formChipChange$: Subject<any> = new Subject<any>();
  constructor() { }
}
